import {
    CustomerSupport,
    DocumentTypeLookup,
    EntityName,
    feature,
    Legaldocuments,
    PaymentMethods,
    PaymentMethodsExtend,
    PlatformID
} from '../..';

export interface AdminAppConfig {
    id: string;
    isMaintenanceModeEnabled: boolean;
    documentTypeLookup: DocumentTypeLookup;
    userIdleTime: number;
    recaptchaUserIdleTime?: number;
    usdtWithdrawMin: number;
    isLegalModalEnabled: boolean;
    availableEntities: EntityName[];
    customerSupport: CustomerSupport;
    externalLegalDocumentsUrl?: string;
    whiteListedRoutes: string[];
    disabledPayments?: PaymentMethods[];
    latestOfficalWebsiteLink?: string;
    referLink?: string;
    isWebtraderEnabled?: boolean;
    roundedCurrencies?: string[];
    feature?: feature;
    enableRegisterPartner?: boolean;
    enabledPaymentDialog?: PaymentMethodsExtend[];
    legaldocuments?: Legaldocuments;
    legalDocumentBaseUrl?: string;
    paymentUserCountryCheckOnly?: PlatformID[];
    countriesForLatinBankWithdrawal?: string[];
    showWithdrawMaintenanceMessage: boolean;
    restrictCountryEnabled?: boolean;
    mapPaymentToGateway?: { [key: string]: string };
    maxFileUploadSize?: number;
    registerPartnerUrl?: string;
    enableMypayAlternateGatewayConfig?: boolean;
    enableEURedirectLink?: boolean;
}
